module.exports = __webpack_public_path__ + "img/bg-mbl-E.c5afb2f5.png";